import { render, staticRenderFns } from "./GJgrowActivityCreate.vue?vue&type=template&id=2c2afe4a&scoped=true&"
import script from "./GJgrowActivityCreate.vue?vue&type=script&lang=ts&"
export * from "./GJgrowActivityCreate.vue?vue&type=script&lang=ts&"
import style0 from "./GJgrowActivityCreate.vue?vue&type=style&index=0&id=2c2afe4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2afe4a",
  null
  
)

export default component.exports